



// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import { mapGetters } from "vuex";

// Constants
import RouteNames from "@/constants/route-names";
import Assets from "@/constants/assets";
import Constants from "@/constants/constants";

// Views
import FormView from "@/shared/views/form.view.vue";
import SaleInfoView from "@/clickbuy/purchase/views/sale-info.view.vue";
import ProductCard, {
  ProductCardColor,
} from "@/clickbuy/purchase/views/product-card.view.vue";
import ProductBranch from "@/clickbuy/purchase/views/product-branch.view.vue";
import ShoppingCart from "@/clickbuy/purchase/views/shopping-cart/index.vue";
import SelectTag from "@/shared/components/select.tag.component.vue";

// Components
import Icon from "@/shared/components/icon.component.vue";
import SaleSNewUser from "@/clickbuy/purchase/views/sales-view/sales-new-user.vue";

import ItemThumb from "@/shared/components/item-thumb.component.vue";
import Btn, {
  BtnPredefinedStyle,
  BtnColor,
  BtnWidth,
} from "@/shared/components/btn.component.vue";
import TextArea, {
  TextareaPredefinedStyle,
} from "@/shared/components/text-area.component.vue";
import InlineSpinner, {
  SpinnerSize,
} from "@/shared/components/inline-spinner.component.vue";
import FieldSet, {
  FieldSetColor,
} from "@/shared/components/field-set.component.vue";
import Modal, {
  ModalTitleColor,
} from "@/shared/components/Modal.component.vue";


// Models
import {
  TypeOfProduct,
  Branch,
  Product,
  TypeOfPriceBackLiteral,
  TypeOfPrice,
} from "@/manager/product/models/product.model";
import { PurchaseLine } from "@/clickbuy/purchase/models/purchase-line.model";
import {
  PaymentMethod,
  PurchasePaymentStatus,
  Purchase,
  PurchaseCompletionStatus,
} from "@/clickbuy/purchase/models/purchase.model.ts";

// Services
import UtilsService from "@/core/services/utils.service";

@Component({
  components: {
    Btn,
    SaleSNewUser,
    FormView,
    Icon,
    InlineSpinner,
    ItemThumb,
    ProductBranch,
    Modal,
    ProductCard,
    SaleInfoView,
    ShoppingCart,
    TextArea,
    FieldSet,
  },
  computed: {
    ...mapGetters({
      currentPurchase: "getCurrentPurchase",
      currentPurchaseReserveAmountWithOutTax:
        "getCurrentPurchaseReserveAmountWithOutTax",
      productList: "getProductList",
      internalBussinessSelected: "getInternalBussinessSelected",
      addingUser: "addingUser",
      productBranch: "getProductBranch",
      clientSelected: "currentPurchaseHasClient",
      purchaseFinished: "currentPurchaseFinished",
      formComplete: "currentPurchaseIsComplete",
      sellingCourses: "currentPurchaseTypeOfProductIsCourse",
      sellingBooks: "currentPurchaseTypeOfProductIsBook",
      sellingMerchandising: "currentPurchaseTypeOfProductIsMerchandising",
      hasPreviousPurchases: "hasPurchases",
      previousPurchaseIsCanceled: "previousPurchaseIsCanceled",
      getTypeOfPrice: "getTypeOfPrice",
    }),
  },
})
export default class SalesView extends Vue {
  @Prop() private convocationId!: string;
  @Prop() private productTypeId!: string;

  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private spinnerSize = SpinnerSize;
  private fieldSetColor = FieldSetColor;
  private currentPurchase!: any;
  private currentPurchaseReserveAmountWithOutTax!: any;
  private internalBussinessSelected!: any;
  private hasPreviousPurchases!: any;
  private getTypeOfPrice!: any;
  private productList!: any;
  private addingUser!: boolean;
  private productBranch!: any;
  private clientSelected!: any;
  private purchaseFinished!: any;
  private formComplete!: any;
  private productListLoaded: boolean = false;
  private disableSendFormBtn = false;
  private requestPending = false;
  private sellingCourses!: boolean;
  private sellingBooks!: boolean;
  private sellingMerchandising!: boolean;
  private previousPurchaseIsCanceled!: boolean;
  private textareaPredefinedStyle = TextareaPredefinedStyle;
  private modalTitleColor = ModalTitleColor;
  private serverError = "";
  private assets = Assets;
  private productCardColor = ProductCardColor;
  private tlpCollapsed = true;
  private specializationCollapsed = true;
  private tlpList: any = [];
  private savedFiscalDataBool: Boolean = false;
  private showWarningNotBillable: boolean = false;


  private error: any = {
    fiscalData: {
      postalCode: "",
      nif: "",
      firstName: "",
      lastName: "",
      email: "",
    },
    client: {
      user: {
        email: "",
        firstName: "",
        lastName: "",
        profile: {
          nif: "",
          phone: "",
          town: ""
        }
      }
    }
  };

  @Watch("internalBussinessSelected")
  public watchGetSelectedClient(newVal: any, oldVal: any) {
    if (newVal) {
      this.fetchProductList();
    }
  }

  private created() {
    this.initializeComponent();
  }

  get typeOfProduct() {
    for (const type in TypeOfProduct) {
      if (type.toLowerCase() === this.productTypeId) {
        return TypeOfProduct[type];
      }
    }
    return TypeOfProduct.Course;
  }

  get hasServerError() {
    return this.serverError !== "";
  }

  get leaderShipBranchProducts() {
    return this.productBranch(Branch.Leadership);
  }

  get businessProducts() {
    return this.productBranch(Branch.Business);
  }

  get noBranchCourses() {
    return this.productBranch(null);
  }

  get tlpCourses() {
    return this.productBranch(null).filter((course: any) => {
      return course.acronym && course.acronym.includes("TLP");
    });
  }

  get specializationCourses() {
    return this.productBranch(null).filter(
      (el: any) => !this.tlpCourses.includes(el)
    );
  }

  get showBranchProducts() {
    return this.productListLoaded && this.sellingCourses;
  }

  get productCardDisable() {
    return (
      !this.clientSelected ||
      (this.hasPreviousPurchases &&
        !this.previousPurchaseIsCanceled &&
        !this.currentPurchase.addNewPurchase) ||
      this.purchaseFinished
    );
  }

  private get specialAnnouncement() {
    return this.$route.query.specialAnnouncement;
  }

  private newPurchase() {
    this.serverError = "";
    const shoppingCart = this.$refs.shoppingCart as ShoppingCart
    const selectTag = shoppingCart.$refs.selectTag as SelectTag

    selectTag.newPurchase();
    shoppingCart.showAddPaymentInfo(false);
  }

  private initializeComponent() {
    this.fetchProductList();
    this.setTypeOfProduct();
    this.newCurrentPurchase();
    // this.fetchPurchaseTags();
    this.emptyAcquiredCourses();
    this.emptyPurchaseList();
    this.fetchTlpList();
  }

  private branchChildMargin(index: number) {
    let classes = "";
    if (index > 1) {
      classes += "branch-child--in-the-middle ";
    }
    if (index % 2 === 0) {
      classes += "branch-child--left-side ";
    } else {
      classes += "branch-child--right-side ";
    }
    return classes;
  }

  private noBranchProductCardColor(product: Product) {
    let color = ProductCardColor.Primary;
    if (product.acronym && product.acronym.includes("TLP")) {
      color = ProductCardColor.Gold;
    }
    return color;
  }

  private backToProductCategorySelection() {
    // if (this.addingUser) {
    //   this.$store.dispatch("setAddingUser", false);
    // } else {
    //   this.$router.push({
    //     query: this.$route.query,
    //     name: RouteNames.cbProductCategory,
    //     params: { id: this.convocationId },
    //   });
    // }
    this.$router.push({ name: RouteNames.cbConvocationList });
  }

  private emptyAcquiredCourses() {
    this.$store.dispatch("setAcquiredCoursesList", []);
  }

  private emptyPurchaseList() {
    this.$store.dispatch("setPurchaseList", []);
  }

  private newCurrentPurchase() {
    this.$store.dispatch("newCurrentPurchase");
  }

  private fetchProductList(
    callback: any = () => {
      const doNothign = 0;
    }
  ) {
    const payload = {
      type_of_product: this.typeOfProduct,
      internal_bussiness_id: null,
    };
    const id =
      this.internalBussinessSelected && this.internalBussinessSelected.id;
    if (id && id !== -1) {
      payload.internal_bussiness_id = id;
    }
    this.$store.dispatch("fetchProductList", payload).then(
      (res) => {
        this.productListLoaded = true;
        callback();
      },
      (err) => {
        this.checkServerError(err);
      }
    );
  }

  //   private fetchPurchaseTags() {
  //     this.$store.dispatch("fetchPurchaseTagList").then(
  //       (res) => {},
  //       (err) => {
  //         this.checkServerError(err);
  //       }
  //     );
  //   }
  //   purchaseTagList
  private clearTextArea() {
    this.currentPurchase.note = "";
  }

  private setTypeOfProduct() {
    this.$store.dispatch("setCurrentPurchaseTypeOfProduct", this.typeOfProduct);
  }

  private setIdProductInPurchaseLines(purchase: Purchase) {
    const newLines = purchase.purchaseLines.map((line: PurchaseLine) => {
      const purchaseLine = Object.assign({}, line);
      try {
        purchaseLine.paymentPending =
          Math.round((purchaseLine.paymentPending || 0) * 100) / 100;
        purchaseLine.totalPrice =
          Math.round((purchaseLine.totalPrice || 0) * 100) / 100;
        purchaseLine.totalPriceTax =
          Math.round((purchaseLine.totalPriceTax || 0) * 100) / 100;
        purchaseLine.totalPriceWithoutTax =
          Math.round((purchaseLine.totalPriceWithoutTax || 0) * 100) / 100;
        purchase.totalPrice =
          Math.round((purchase.totalPrice || 0) * 100) / 100;
        purchase.totalPriceWithoutTax =
          Math.round((purchase.totalPriceWithoutTax || 0) * 100) / 100;
        purchase.totalPaymentPending =
          Math.round((purchase.totalPaymentPending || 0) * 100) / 100;
        purchase.reserveAmount =
          Math.round((purchase.reserveAmount || 0) * 100) / 100;
      } catch (_) {
        console.log("try catch error in sales-view");
      }
      const productId = (purchaseLine.product as any).id;
      delete purchaseLine.product;
      delete purchaseLine.color;
      return {
        product: productId,
        ...purchaseLine,
      };
    });
    purchase.purchaseLines = newLines;
  }

  private checkServerError(err: any) {
    const response = err.response;
    if (response.status === 500) {
      this.serverError = Constants.internalServerErrorMessage;
    } else {
      this.serverError = response.statusText;
      if (response.data.phone) {
        this.serverError += ": " + response.data.phone
      } else if (response.data.client.user.profile.nif) {
        this.serverError += ": " + response.data.client.user.profile.nif
      } else if (response.data.client.user.profile.phone) {
        this.serverError += ": " + response.data.client.user.profile.phone
      }
    }
    // setTimeout(() => {
    //   this.serverError = "";
    // }, Constants.notificationMessageTimeToAppear);
  }

  private checkFiscalDataExtension() {
    let result = true;

    // Validación fiscal data
    const fiscalDataNif = (this.currentPurchase.fiscalData as any).nif;
    if (!fiscalDataNif || fiscalDataNif === "") {
      this.error.fiscalData.nif = "Campo vacío";
      result = false;
    }

    const postalCode = (this.currentPurchase.fiscalData as any).postalCode;
    if (!postalCode || postalCode === "") {
      this.error.fiscalData.postalCode = "Campo vacío";
      result = false;
    } else if (!postalCode || postalCode.trim().length < 5) {
      this.error.fiscalData.postalCode = "CP está incompleto";
      result = false;
    }

    const firstName = (this.currentPurchase.fiscalData as any).firstName;
    if (!firstName || firstName === "" || firstName === "SIN DATOS") {
      this.error.fiscalData.firstName = "Campo obligatorio";
      result = false;
    }

    const lastName = (this.currentPurchase.fiscalData as any).lastName;
    if (!lastName || lastName === "" || lastName === "SIN DATOS") {
      this.error.fiscalData.lastName = "Campo obligatorio";
      result = false;
    }

    const email = (this.currentPurchase.fiscalData as any).email;
    if (!email || email === "" || email === "SIN@DATOS.COM") {
      this.error.fiscalData.email = "Campo obligatorio";
      result = false;
    }
    return result;
  }

  private savedFiscalData(data: Boolean) {
    this.savedFiscalDataBool = data;
  }


  private sendForm() {
    this.serverError = ""
    this.showWarningNotBillable = false;
    if (this.checkFiscalDataExtension() && this.formComplete && this.savedFiscalDataBool && this.currentPurchase.fiscalDataExtensionId) {
      const currentDate = new Date().toLocaleString();

      if (this.specialAnnouncement) {
        this.currentPurchase.isVo = true;
      }

      // const currentHour = currentDate.getHours();
      // const currentMinute = currentDate.getMinutes();
      let saldoAFavorString = (this.currentPurchase.totalPrice) < 0 ? '\nSaldo a favor: ' + (-this.currentPurchase.totalPrice) + '€.' : ''
      let prontoPagoString = this.currentPurchase.soonPaymentDiscount ? 'Dto. Pronto Pago: ' + this.currentPurchase.soonPaymentDiscount + '€. ' : ' ';
      let productAcronyms = ''
      this.currentPurchase.purchaseLines.forEach((item: any) => {
        productAcronyms += item.product.acronym?item.product.acronym + '. ': item.product.name +  '. '
      })
      if (this.currentPurchase.note) {
        this.currentPurchase.note += '\nFecha: ' + currentDate + ' - ' + productAcronyms + ' Pago ' + this.paymentMethod(this.currentPurchase) + ' ' + (this.currentPurchase.totalPrice) + '€. ' + prontoPagoString + saldoAFavorString;
      } else {
        this.currentPurchase.note = 'Fecha: ' + currentDate + ' - ' + productAcronyms + ' Pago ' + this.paymentMethod(this.currentPurchase) + ' ' + (this.currentPurchase.totalPrice) + '€. ' + prontoPagoString + saldoAFavorString;
      }
      this.setTyeOfPriceToPurchaseLine();
      const purchase = Object.assign({}, this.currentPurchase);
      // return;
      purchase.convocationOrigin = this.convocationId;
      // purchase.reserveAmount = this.currentPurchaseReserveAmountWithOutTax;
      purchase.paymentStatus = PurchasePaymentStatus.Paid;
      // purchase.client.topLevelPack = true;
      // purchase.client.tlp = this.tlpList;
      // console.log(this.tlpList);

      // purchase.completionStatus = PurchaseCompletionStatus.Finished;
      this.setIdProductInPurchaseLines(purchase);

      if (purchase.voucherOwner === null || !purchase.voucherNumber) {
        console.warn("borro el voucherOwner");
        delete purchase.voucherOwner;
        delete purchase.voucherNumber;
      }
      this.disableSendFormBtn = true;
      this.requestPending = true;
      if (!this.purchaseFinished) {
        this.$store.dispatch("newPurchase", { newPurchase: purchase }).then(
          (res) => {
            this.serverError = ""
            this.savedFiscalDataBool = false;
            const newPurchase = Object.assign({}, this.currentPurchase);
            newPurchase.paymentStatus = PurchasePaymentStatus.Paid;
            newPurchase.id = res.id;
            newPurchase.addNewPurchase = true;
            this.$store.dispatch("setCurrentPurchase", newPurchase);
            setTimeout(() => {
              const params = {
                id: this.convocationId,
                client: this.currentPurchase.client.user.id
              };
              this.$store.dispatch("fetchPurchaseList", params);
              this.disableSendFormBtn = false;
              this.requestPending = false;
            }, 10000);
          },
          (err) => {
            this.checkServerError(err);
            this.disableSendFormBtn = false;
            this.requestPending = false;
          }
        );
      } else {
        // this.currentPurchase.purchaseLines.forEach((purchaseLine:any) => {
        //   purchaseLine.product.id ? purchaseLine.product = purchaseLine.product.id : purchaseLine.product
        // });
        // console.log(this.currentPurchase.previousReserveAmount)
        if ((this.currentPurchase.reserveAmount - this.currentPurchase.previousReserveAmount) < 0) {
          this.currentPurchase.moneyFlowBase = this.currentPurchase.previousReserveAmount - this.currentPurchase.reserveAmount;
          let tag = {
            "id": "e58481ac-8276-458a-b7d7-e01763768aa8",
            "name": "SALDO"
          }
          this.currentPurchase.tags.push(tag);
        }
        // this.currentPurchase.totalPrice = this.currentPurchase.totalPrice - this.currentPurchase.previousReserveAmount
        // this.currentPurchase.reserveAmount = this.currentPurchase.previousReserveAmount + (this.currentPurchase.totalPrice - this.currentPurchase.previousReserveAmount)
        // this.currentPurchase.totalPriceWithoutTax = this.currentPurchase.totalPriceWithoutTax - this.currentPurchase.previousReserveAmount
        // if (this.currentPurchase.totalPrice < 0) {
        //   let tag = {
        //     "id": "94f35b30-dce1-4c55-b646-19404dd28cfb",
        //     "name": "SALDO"
        //   }
        //   this.currentPurchase.tags.push(tag);
        // }
        // this.currentPurchase.purchaseLines[0].product = this.currentPurchase.purchaseLines[0].product.id
        const purchase = Object.assign({}, this.currentPurchase);
        this.$store.dispatch("updatePurchase", { ...purchase }).then(
          (res) => {
            this.currentPurchase.modifyPurchase = false;
            // this.currentPurchase.previousReserveAmount = 0;
            const newPurchase = Object.assign({}, this.currentPurchase);
            newPurchase.paymentStatus = PurchasePaymentStatus.Paid;
            newPurchase.id = res.id;
            newPurchase.addNewPurchase = true;
            this.$store.dispatch("setCurrentPurchase", newPurchase);
            setTimeout(() => {
              const params = {
                id: this.convocationId,
                client: this.currentPurchase.client.user.id
              };
              this.$store.dispatch("fetchPurchaseList", params);
            }, 1000);
            this.disableSendFormBtn = false;
            this.requestPending = false;
          },
          (err) => {
            this.checkServerError(err);
            this.disableSendFormBtn = false;
            this.requestPending = false;
          }
        );
      }
    }
    else if (!this.checkFiscalDataExtension() || !this.savedFiscalDataBool) {
      this.checkServerError({ 'response': { 'statusText': 'No has dado a Facturar aquí: Bad Request: Bloque Facturación.' } })
    }
    else if (this.currentPurchase.paymentMethod == 2 && !this.currentPurchase.cardLastDigits) {
      this.checkServerError({ 'response': { 'statusText': 'No has indicado los 4 dígitos de la tarjeta: Bad Request: 4 dígitos de tarjeta.' } })
    }
    else if (!this.currentPurchase.fiscalDataExtensionId) {
      this.checkServerError({ 'response': { 'statusText': 'Bad Request: Datos fiscales insuficientes.' } })
    }
  }

  private paymentMethod(purchase: any) {
    let paymentMethodName = "";
    if (PaymentMethod.Cash === parseInt(purchase.paymentMethod)) {
      paymentMethodName = "Efectivo";
    } else if (PaymentMethod.Card === parseInt(purchase.paymentMethod)) {
      paymentMethodName = "Tarjeta";
    } else if (PaymentMethod.DirectDebit === parseInt(purchase.paymentMethod)) {
      paymentMethodName = "Domiciliación";
    } else if (PaymentMethod.SendWireTransfer === parseInt(purchase.paymentMethod)) {
      paymentMethodName = "Transferencia";
    } else if (PaymentMethod.Bizum === parseInt(purchase.paymentMethod)) {
      paymentMethodName = "Bizum";
    }
    return paymentMethodName;
  }

  private setTyeOfPriceToPurchaseLine() {
    if (this.typeOfProduct === TypeOfProduct.Course) {
      const key = TypeOfPriceBackLiteral[this.getTypeOfPrice];
      this.currentPurchase.purchaseLines.forEach((line: any) => {
        if (line.repeater) {
          line[TypeOfPriceBackLiteral[TypeOfPrice.Repeat]] = true;
        } else {
          line.repeater = this.getTypeOfPrice === TypeOfPrice.Repeat;
          line[key] = true;
        }
      });
      this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
    }
  }

  private fetchTlpList() {
    this.$store.dispatch("fetchTlpList").then((res) => {
      this.tlpList = res[0];
    });
  }

  private toggleShowWarningNotBillable(value: boolean) {
    if (this.currentPurchase.notBillable && !(this.currentPurchase.modifyPurchase && this.currentPurchase.soonPaymentPurchaseCheck && (this.currentPurchase.totalPrice) < 0 && this.currentPurchase.purchaseLines.length > 0)) {
      this.showWarningNotBillable = value
    } else {
      this.sendForm();//xd
    }
  }

}
